import React from "react";
import { ChevronDown } from "lucide-react";
import site from "@/seo/site.json";

const SERVICES = ["صيانة عامة", "كهرباء سيارات", "سمكرة ودهان", "تغيير زيت", "صيانة مكيف", "فحص كمبيوتر", "سطحة 24 ساعة"];

export function CitiesIntro() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 pt-16" data-testid="home-cities-section">
      <h2 className="font-heading text-2xl sm:text-3xl font-extrabold mb-4">{site.home.h2}</h2>
      <p className="text-muted-foreground leading-relaxed max-w-3xl">{site.home.paragraph}</p>
      <ul className="flex flex-wrap gap-2 mt-5">
        {SERVICES.map((s) => <li key={s} className="rounded-full border border-border bg-card px-4 py-1.5 text-sm font-semibold">{s}</li>)}
      </ul>
    </section>
  );
}

export function HomeFaq() {
  return (
    <section className="max-w-3xl mx-auto px-4 sm:px-6 py-16" data-testid="home-faq-section">
      <h2 className="font-heading text-2xl sm:text-3xl font-extrabold text-center mb-8">{site.home.faqTitle}</h2>
      <div className="space-y-3">
        {site.home.faq.map((f, i) => (
          <details key={i} className="group bg-card border border-border rounded-2xl p-5" data-testid={`faq-item-${i}`}>
            <summary className="flex items-center justify-between gap-3 cursor-pointer list-none font-bold">
              <h3 className="text-base">{f.q}</h3>
              <ChevronDown className="w-5 h-5 shrink-0 transition-transform group-open:rotate-180" />
            </summary>
            <p className="text-sm text-muted-foreground leading-relaxed mt-3">{f.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
